
















import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect
    },
    data: function() {
        return {
            pathInStore: "property.energy.heatingType"
        };
    },
    computed: {
        typeOfHeating: function(): string|null {
            return this.$store.getters["FormModule/getValue"](this.pathInStore);
        },
        isDisplayed: function(): boolean {
            return ["HOUSE","OFFICE","INDUSTRY","COMMERCIAL","APARTMENT","OTHER","HOMES_TO_BUILD"].indexOf(this.getPropertyType()) !== - 1;
        },
        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("undefined"),
                    "value": ""
                },
                {
                    "label": this.$t("carbon"),
                    "value": "CARBON"
                },
                {
                    "label": this.$t("electric"),
                    "value": "ELECTRIC"
                },
                {
                    "label": this.$t("gas"),
                    "value": "GAS"
                },
                {
                    "label": this.$t("fueloil"),
                    "value": "FUELOIL"
                },
                {
                    "label": this.$t("wood"),
                    "value": "WOOD"
                },
                {
                    "label": this.$t("pellet"),
                    "value": "PELLET"
                },
                {
                    "label": this.$t("solar"),
                    "value": "SOLAR"
                }
            ];
        }
    },
    methods: {
        updateValue: function(typeOfHeatingValue: string): void {
            if (typeOfHeatingValue === "") {
                this.$store.commit("FormModule/deleteValue", this.pathInStore);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStore, "value": typeOfHeatingValue});
            }
        }
    },
});
